module.exports = __webpack_public_path__ + "img/pram-white.99fe78b2.png";